/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import { Divider, IconButton, Tooltip, useMediaQuery } from "@mui/material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { IDataFromModal } from "../../pages/Workspace/interface";
import { initialContextMenu } from "../../Utils/common";
import { globalColors } from "../../Utils/colors";
import ActionsContextMenu from "../ActionsContextMenu";
import "./style.scss";

import {
  BodyContainer,
  CardContainer,
  CardIconsContainer,
  CardPreviewContainer,
  CardItemsContainer,
  CardTextContainer,
  HeaderContainer,
  RootContainer,
  CardPreview,
  CardPreviewImage,
  CardIconWrapper,
  CardAddNewButtonContainer,
  AltImage,
} from "./styled";

import {
  ContentScreenAddIcon,
  ContentScreenClipboardIcon,
  ContentScreenDeleteIcon,
  ContentScreenDragIcon,
  ContentScreenPlusIcon,
} from "../Custom/Buttons/ButtonIcons";

interface ContentProps {
  setAllQuestionTypes: (value: boolean) => void;
  setQuestionFormData: (value: any) => void;
  setDataFormSettings: (value: any) => void;
  dataFormSettings: any;
  selectedData: any;
  handleSelected: (value: any) => void;
  handleDelete: (value: number) => void;
  landingPage: boolean;
  setSubmitToggle: (e: boolean) => void;
  submitToggle: boolean;
  setSubmitType: (e: string) => void;
  setPrevSelected: (e: any) => void;
  dragDisable: boolean;
  setaddNewIndex: (e: number) => void;
  contextMenu: any;
  setContextMenu: (e: any) => void;
  storeHistory: (field: string, value: any, type: string) => void;
  formState: any;
  dataFromModal: IDataFromModal;
  background: string;
}

function ContentCard({
  setAllQuestionTypes,
  dataFormSettings,
  handleSelected,
  handleDelete,
  landingPage,
  selectedData,
  setQuestionFormData,
  setDataFormSettings,
  setSubmitToggle,
  submitToggle,
  setSubmitType,
  setPrevSelected,
  dragDisable,
  setaddNewIndex,
  contextMenu,
  setContextMenu,
  storeHistory,
  formState,
  dataFromModal,
  background,
}: ContentProps) {
  const [currentIndex] = useState<number | null>(null);
  const isLessThan1280 = useMediaQuery("(max-width:1281px)");
  const [disableSelect, setDisableSelect] = useState<boolean>(false);

  useEffect(() => {
    setAllQuestionTypes(true);
  }, []);

  const handleDragEnd = (result: any) => {
    if (!result.destination || dragDisable) return; // Return if dropped outside a droppable area
    const { source, destination } = result;
    storeHistory(
      "swap-question",
      { data: dataFormSettings, index: destination.index },
      "form-content"
    );
    const newDataFormSettings = Array.from(dataFormSettings);
    const [removed] = newDataFormSettings.splice(source.index, 1); // Remove the dragged item from the original position
    newDataFormSettings.splice(destination.index, 0, removed); // Insert the dragged item at the new position
    setDataFormSettings(newDataFormSettings); // Update the state with the new order of items
    setQuestionFormData(newDataFormSettings);
    const selectedFields = newDataFormSettings[destination.index];
    handleSelected({ fields: selectedFields, index: destination.index });
  };

  const submitForm = () => {
    setTimeout(() => {
      setSubmitToggle(!submitToggle);
    }, 100); //need a little delay to perform validation by useForm
  };

  const handleDragStart = () => {
    setSubmitType("selection");
    submitForm();
  };

  const closeContextMenu = () => {
    setContextMenu(initialContextMenu);
  };

  const handleDuplicate = () => {
    setSubmitType("duplicate");
    submitForm();
  };

  return (
    <RootContainer>
      <HeaderContainer>Content Screens</HeaderContainer>
      <Divider />
      {contextMenu.show && (
        <ActionsContextMenu
          x={contextMenu.x}
          y={contextMenu.y}
          closeContextMenu={closeContextMenu}
          handleDelete={() =>
            (currentIndex || currentIndex === 0) && handleDelete(currentIndex)
          }
          handleaddSlides={() => {
            setSubmitType(`add-middle`);
            (currentIndex || currentIndex === 0) &&
              setaddNewIndex(currentIndex);
            submitForm();
          }}
          handleDuplicate={() =>
            (currentIndex || currentIndex === 0) && handleDuplicate()
          }
          isFirstElement={dataFormSettings?.length === 1}
        />
      )}
      <BodyContainer>
        <DragDropContext
          onDragEnd={handleDragEnd}
          onDragStart={handleDragStart}
        >
          <Droppable droppableId="content-card-list">
            {(provided, snapshot) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                {landingPage && (
                  <div
                    className={`content-card landing ${snapshot.isDraggingOver ? "dragging-over" : ""
                      }`}
                  >
                    <div
                      className={`content-details landing-content ${selectedData.index === "" ? "active" : ""
                        }`}
                    >
                      <CardContainer
                        className={selectedData.index === -1 ? "" : "left-card-container"}
                        bgColor={
                          selectedData.index === -1
                            ? globalColors.calmLightDark
                            : globalColors.white
                        }
                        onClick={() => {
                          setSubmitType("selection");
                          setPrevSelected({
                            fields: {},
                            index: -1,
                          });
                          submitForm();
                        }}
                      >
                        <CardItemsContainer container>
                          {!isLessThan1280 && (
                            <CardPreviewContainer item xs={10}>
                              <CardPreview borderColor={globalColors.primary}>
                                {
                                  formState.watch(
                                    "styles.landingPageBackground"
                                  ) || dataFromModal?.landingPageBackground || dataFromModal?.backGround ?
                                    <CardPreviewImage
                                      alt="bg"
                                      src={
                                        formState.watch(
                                          "styles.landingPageBackground"
                                        ) || dataFromModal?.landingPageBackground || dataFromModal?.backGround
                                      }
                                    />
                                    : <AltImage style={{
                                      background:
                                        formState.watch(
                                          "styles.backgroundColor"
                                        ) || dataFromModal?.backgroundColor
                                    }}></AltImage>
                                }
                              </CardPreview>
                            </CardPreviewContainer>
                          )}
                          <CardIconsContainer item xs={2}>
                            <CardIconWrapper>
                              <IconButton
                                onClick={() => {
                                  handleDelete(-1);
                                }}
                              >
                                <ContentScreenDeleteIcon
                                  color={
                                    selectedData.index === -1
                                      ? globalColors.white
                                      : globalColors.primary
                                  }
                                  disabled={false}
                                />
                              </IconButton>
                            </CardIconWrapper>
                          </CardIconsContainer>
                        </CardItemsContainer>
                        <CardTextContainer
                          color={
                            selectedData.index === -1
                              ? globalColors.white
                              : globalColors.primary
                          }
                        >
                          Welcome Page
                        </CardTextContainer>
                      </CardContainer>
                    </div>
                  </div>
                )}
                {Boolean(dataFormSettings?.length) &&
                  dataFormSettings?.map((data: any, keys: number) => {
                    const isSelected = selectedData.index === keys;

                    const backgroundImageUrl = isSelected
                      ? data?.styles?.background ||
                      formState.watch("styles.background") ||
                      dataFromModal?.backGround
                      : data?.styles?.background || dataFromModal?.backGround;
                    const cardBackgroundColor = isSelected
                      ? globalColors.calmLightDark
                      : globalColors.white;

                    const contentColor = isSelected
                      ? globalColors.white
                      : globalColors.primary;

                    return (
                      <Draggable
                        key={keys}
                        draggableId={`content-card-${keys}`}
                        index={keys}
                      >
                        {(provided, snapshot) => (
                          <div
                            className={`content-card ${selectedData.index === keys ? "active" : ""
                              } ${snapshot.isDragging ? "dragging" : ""}`}
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                          >
                            <CardContainer
                              className={isSelected ? "" : "left-card-container"}
                              id="cards"
                              bgColor={cardBackgroundColor}
                              onClick={() => {
                                if (!disableSelect) {
                                  setSubmitType("selection");
                                  setPrevSelected({
                                    fields: data,
                                    index: keys,
                                  });
                                  submitForm();
                                }
                              }}
                            >
                              <CardItemsContainer container>
                                {!isLessThan1280 && (
                                  <CardPreviewContainer item xs={6}>
                                    <CardPreview borderColor={contentColor}>
                                      {backgroundImageUrl ?
                                        <CardPreviewImage
                                          alt="bg"
                                          src={backgroundImageUrl}
                                        />
                                        : <AltImage style={{
                                          background:
                                            data?.styles?.backgroundColor ||
                                            formState.watch("styles.backgroundColor") ||
                                            dataFromModal?.backgroundColor || data?.styles?.backgroundColor
                                        }}></AltImage>
                                      }
                                    </CardPreview>
                                  </CardPreviewContainer>
                                )}
                                <CardIconsContainer
                                  item
                                  xs={isLessThan1280 ? 12 : 6}
                                >
                                  <CardIconWrapper>
                                    <Tooltip title="Add question below">
                                      <IconButton
                                        onMouseEnter={() =>
                                          setDisableSelect(true)
                                        }
                                        onMouseLeave={() =>
                                          setDisableSelect(false)
                                        }
                                        disabled={
                                          dataFormSettings?.length - 1 === keys
                                        }
                                        onClick={() => {
                                          setSubmitType(`add-middle`);
                                          setaddNewIndex(keys);
                                          submitForm();
                                        }}
                                      >
                                        <ContentScreenAddIcon
                                          color={contentColor}
                                          disabled={
                                            dataFormSettings?.length - 1 ===
                                            keys
                                          }
                                        />
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Duplicate question">
                                      <IconButton
                                        onMouseEnter={() =>
                                          setDisableSelect(true)
                                        }
                                        onMouseLeave={() =>
                                          setDisableSelect(false)
                                        }
                                        onClick={() => {
                                          setSubmitType(`duplicate`);
                                          setaddNewIndex(keys);
                                          submitForm();
                                        }}
                                      >
                                        <ContentScreenClipboardIcon
                                          color={contentColor}
                                          disabled={false}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Delete">
                                      <IconButton
                                        disabled={data?.html}
                                        onClick={() => {
                                          handleDelete(keys);
                                        }}
                                      >
                                        <ContentScreenDeleteIcon
                                          color={
                                            data?.html
                                              ? globalColors.disabledColor
                                              : contentColor
                                          }
                                          disabled={false}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  </CardIconWrapper>
                                  <CardIconWrapper>
                                    <Tooltip title="Drag to reorder">
                                      <IconButton {...provided.dragHandleProps}>
                                        <ContentScreenDragIcon
                                          color={contentColor}
                                          disabled={false}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  </CardIconWrapper>
                                </CardIconsContainer>
                              </CardItemsContainer>
                              <CardTextContainer
                                color={contentColor}
                                dangerouslySetInnerHTML={{ __html: `${keys + 1} ${data?.title || ''}` }}
                              />
                            </CardContainer>
                          </div>
                        )
                        }
                      </Draggable>
                    );
                  })}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        <CardAddNewButtonContainer>
          <IconButton onClick={submitForm}>
            <ContentScreenPlusIcon />
          </IconButton>
        </CardAddNewButtonContainer>
      </BodyContainer>
    </RootContainer >
  );
}

export default ContentCard;
